import React from "react";
import "./HoverInsertText.css";
import Form from "react-bootstrap/Form";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import { generateUniqueID, autosize } from "../../utils/utils";

class HoverInsertText extends React.Component {
  constructor(props) {
    super(props);
    this.onHover = this.onHover.bind(this);
    this.clicked = this.clicked.bind(this);

    this.textRef = React.createRef();
    this.state = { hovering: false };

    this.textAreaID = generateUniqueID();
  }

  onHover(hovering) {
    this.setState({ hovering: hovering });
  }

  clicked(insertText) {
    this.textRef.focus();

    const newText = insertAtCaret(this.textAreaID, insertText);
    const fakeE = {
      target: { value: newText }
    };

    this.props.onChange(fakeE);
  }

  componentDidMount() {
    if (!this.props.noautosize) {
      autosize(this.textRef);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.value !== prevProps.value ||
        this.props.as !== prevProps.as) &&
      !this.props.noautosize
    ) {
      autosize(this.textRef);
    }
  }

  render() {
    const { hovering } = this.state;
    let { style, hidehtml } = this.props;

    style = style == null ? {} : style;

    return (
      <div style={style}>
        <Form.Control
          id={this.textAreaID}
          ref={el => (this.textRef = el)}
          {...this.props}
        />
        {!hidehtml && (
          <div
            className="hover_text_btn_container"
            style={{ opacity: hovering ? 0.7 : 0.3 }}
            onMouseEnter={() => this.onHover(true)}
            onMouseLeave={() => this.onHover(false)}
          >
            <ButtonGroup size="sm">
              <Button
                size="sm"
                className="hover_text_btn"
                variant="info"
                onClick={() => this.clicked("[]()")}
              >
                <span className="fa fa-link" />
              </Button>
              <Button
                size="sm"
                className="hover_text_btn"
                variant="info"
                onClick={() => this.clicked("****")}
              >
                <span className="fa fa-bold" />
              </Button>
              <Button
                size="sm"
                className="hover_text_btn"
                variant="info"
                onClick={() => this.clicked("{,}")}
              >
                <span className="fa fa-jpy" />
              </Button>
            </ButtonGroup>
          </div>
        )}
      </div>
    );
  }
}

export default HoverInsertText;

//http://www.scottklarr.com/topic/425/how-to-insert-text-into-a-textarea-where-the-cursor-is/
function insertAtCaret(areaId, text) {
  var txtarea = document.getElementById(areaId);
  var scrollPos = txtarea.scrollTop;
  var strPos = 0;
  var br =
    txtarea.selectionStart || txtarea.selectionStart === "0"
      ? "ff"
      : document.selection
      ? "ie"
      : false;
  if (br === "ie") {
    txtarea.focus();
    var range = document.selection.createRange();
    range.moveStart("character", -txtarea.value.length);
    strPos = range.text.length;
  } else if (br === "ff") strPos = txtarea.selectionStart;

  var front = txtarea.value.substring(0, strPos);
  var back = txtarea.value.substring(strPos, txtarea.value.length);
  txtarea.value = front + text + back;
  strPos = strPos + text.length;
  if (br === "ie") {
    txtarea.focus();
    range = document.selection.createRange();
    range.moveStart("character", -txtarea.value.length);
    range.moveStart("character", strPos);
    range.moveEnd("character", 0);
    range.select();
  } else if (br === "ff") {
    txtarea.selectionStart = strPos;
    txtarea.selectionEnd = strPos;
    txtarea.focus();
  }
  txtarea.scrollTop = scrollPos;

  return txtarea.value;
}
